// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3cAyu","amount":"Amount_amount__217oe","tip":"Amount_tip__3Kfb6","tipHeader":"Amount_tipHeader__2FqQZ","tipsWrap":"Amount_tipsWrap__Jqj6w"};